import React from 'react';
import { motion } from 'framer-motion';
import { getThemeClass } from '../../../../lib/theme';
import { cn } from '../../../../lib/utils';

const HeroSection = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <section className={`relative min-h-[90vh] flex items-center justify-center ${getThemeClass('gradients.hero')}`}>
      {/* Dot matrix overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMSIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==')]" />
      
      <div className="container mx-auto px-6 py-24 flex justify-center">
        <div className="w-full max-w-4xl">
          <div>
            <motion.div
              initial="initial"
              animate="animate"
            >
              {/* Title */}
              <div className="mb-6">
                <motion.div variants={fadeIn}>
                  <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 text-center user-select-all">
                    Principal Member of Technical Staff
                    <span className={cn("block", getThemeClass('colors.primary.light', 'text'))}>
                      Technical Innovation Architect
                    </span>
                  </h1>                  
                </motion.div>
              </div>

              {/* Introduction */}
              <div className="mb-12">
                <motion.div variants={fadeIn}>
                  <p className={cn("text-lg md:text-xl leading-relaxed mb-12", getThemeClass('colors.secondary.light', 'text'))}>
                    Principal Member of Technical Staff with a proven track record of transforming complex technical domains through user-centric innovation. From edge computing and content delivery networks to distributed data systems and enterprise platforms, consistently architect solutions that combine technical excellence with measurable business impact.
                  </p>                   
                </motion.div>
              </div>

              {/* Key Innovation Areas */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    title: "Content Delivery & Edge Computing",
                    metric: "80%",
                    description: "Bandwidth reduction while maintaining quality"
                  },
                  {
                    title: "Platform Architecture",
                    metric: "Full-Stack",
                    description: "Multi-platform subscription system with integrated global payments & billing"
                  },
                  {
                    title: "Distributed Systems",
                    metric: "85%",
                    description: "API latency improvement through innovative caching"
                  }
                ].map((area, index) => (
                  <div key={index} 
                    className={cn(
                      "bg-white/10",
                      "backdrop-blur-sm",
                      "rounded-lg",
                      "p-6",
                      "border",
                      "border-white/20",
                      "transition-colors",
                      "duration-300",
                      getThemeClass('colors.primary.light', 'borderHover')
                    )}>
                    <motion.div variants={fadeIn}>
                      <h3 className="text-lg font-semibold text-white mb-2">{area.title}</h3>                      
                      <p className={cn("text-3xl font-bold", getThemeClass('colors.primary.light', 'text'))}>
                        {area.metric}
                      </p>
                      <p className={cn(getThemeClass('colors.text.light', 'text'))}>
                          {area.description}
                      </p>
                    </motion.div>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;